export const printTemplateList = [
  {
    id: 1,
    name: '单个或多个业务销售合同'
  }, {
    id: 2,
    name: '单个业务-不含检测报告及配件费明细'
  }, {
    id: 3,
    name: '单个业务-含检测报告不含配件费明细'
  }, {
    id: 4,
    name: '单个业务-含检测报告及配件费明细'
  }, {
    id: 5,
    name: '多个业务-不含检测报告及配件费明细'
  }
]

export const descriptionStyle = `
.table-descri{
  border: 1px solid #E2E2E2;
  border-bottom: 0;
  margin-bottom: 20px;
}
.table-descri-li{
  display: flex;
  border-bottom: 1px solid #E2E2E2;
  align-items: center;
}
.table-descri-lable{
  display: block;
  width: 180px;
  padding: 10px;
  text-align: center;
}
.table-descri-content{
  flex: 1;
  display: block;
  padding: 10px;
  border-left:  1px solid #E2E2E2;
  min-height: 36px;
}
`
export const tablePrint = {
  // 自定义打印的样式示例
  style: `
  .vxe-table {
    color: #000000; // 修改表格默认颜色
    font-size: 12px; // 修改表格默认字体大小
  }
  .vxe-table,
  .vxe-table thead th,
  .vxe-table tbody td,
  .vxe-table tfoot td  {
    border:1px solid #000000;
    // border-color: #000000; // 修改表格边框颜色
  }
  .vxe-table thead th {
    font-size: 14px; // 修改表头默认字体大小
  }
  .vxe-table tfoot td {
  }
  pre {
    white-space: pre-wrap;
    word-break: break-all;
    max-width: 100%;
    font-family: inherit;
  }
  #part1, #part2 {
    max-width: 100%;
  }
  @page {
    size: A4;
    margin: 10mm;
  }
  `
}

export const signContainer = `
  .sign-container-border{
    border: 1px solid rgba(0,0,0,.7);
    height: 0px;
    width: 200px;
    display: inline-block;
  }
  .upload-file_preview{
    position: absolute;
    top: -45px;
    left: 130px;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-all;
    max-width: 100%;
    font-family: inherit;
  }
  #part1, #part2 {
    max-width: 100%;
  }
`
